export const Constants = {
	Layout: {
		MobileScreenWidth: 800,
	},
};
